export const parseJson = (json: string | Record<string, any>) => {
  let parsedJson;
  try {
    parsedJson = typeof json === 'string' ? JSON.parse(json) : json;
  } catch {}

  return parsedJson || {};
};
